//课中活动讨论
export const QUES_LIST = 'ques_list'
export const QUES_INFO = 'ques_info'
export const ANS_LIST = 'ans_list'